export default {
  computed: {
    $m_ie_isLegacy() {
      return !!document.documentMode;
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/mixins/ie.js